'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.sortBuilderFactory = sortBuilderFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _sortMixin2 = require('./sortMixin');

var _sortMixin3 = _interopRequireDefault(_sortMixin2);

var _errors = require('../errors');

var QuerySort = (function (_sortMixin) {
  _inherits(QuerySort, _sortMixin);

  function QuerySort() {
    _classCallCheck(this, QuerySort);

    _get(Object.getPrototypeOf(QuerySort.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(QuerySort, [{
    key: '_build',
    value: function _build() {
      throwErrorIfInvalid(this.invalidArguments);
      return this.orderBy;
    }
  }]);

  return QuerySort;
})((0, _sortMixin3['default'])());

function throwErrorIfInvalid(invalidArguments) {
  if (invalidArguments.length > 0) {
    throw (0, _errors.validationError)(_errors.messages.sortBuilderInvalid(invalidArguments));
  }
}

function sortBuilderFactory() {
  return new QuerySort(undefined);
}

exports['default'] = sortBuilderFactory;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/sort/sortBuilder.js
// module id = 245
// module chunks = 0